"use client";
import { AuthContext } from "./AuthContext";
import { useProvideAuth } from "../hooks/useProvideAuth";

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const auth = useProvideAuth();
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};
